export default __webpack_public_path__ + "static/media/androgenetic-alopecia.2f9ef94e.JPG";